import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 2v.924c0 .182.07.358.198.493l3.91 4.131c.165.174.256.4.256.635V14l3.272-1.048V7.764c0-.25.104-.49.288-.667l3.852-3.7a.72.72 0 0 0 .224-.52V2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }